'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _handleActions;

var _reduxActions = require('redux-actions');

var _ActionTypes = require('conversations-core/constants/ActionTypes');

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

var _WidgetData = require('conversations-schema/records/WidgetData');

var _WidgetData2 = _interopRequireDefault(_WidgetData);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = new _WidgetData2.default();

exports.default = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, _ActionTypes2.default.GET_WIDGET_DATA_SUCCEEDED, function (state, action) {
  return action.payload;
}), _defineProperty(_handleActions, _ActionTypes2.default.SEND_VISITOR_EMAIL_ADDRESS_SUCCEEDED, function (state) {
  return state.set('hasVisitorEmail', true);
}), _handleActions), initialState);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/reducers/widgetData.js
// module id = 558
// module chunks = 0